(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-base"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__lpBase) return;
  window.__lpBase = true;
  var FALLBACK = '[id^="ProductInfo-"]';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function find(sel) {
    var el = null;
    if (sel) { try { el = document.querySelector(sel); } catch (e) {} }
    return el || document.querySelector(FALLBACK);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-lp-scroll]') : null;
    if (!a) return;
    var el = find(a.getAttribute('data-lp-target'));
    if (!el) return;
    e.preventDefault();
    el.style.scrollMarginTop = '8rem';
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  function initSticky(bar) {
    if (bar.__lpReady) return;
    bar.__lpReady = true;
    var tries = 0;
    (function bind() {
      var el = find(bar.getAttribute('data-lp-target'));
      if (!el) { if (tries++ < 10) setTimeout(bind, 500); return; }
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -10% 0px' }).observe(el);
    })();
  }

  function boot() {
    var bars = document.querySelectorAll('[data-lp-sticky]');
    for (var i = 0; i < bars.length; i++) initSticky(bars[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

})();
